import { apiClient } from './api-client';
import { ApiResponse, Note, ListNotesResponse } from '../types';

export const NoteService = {
  /**
   * Get notes by chapter ID
   * @param chapterId The ID of the chapter to get notes for
   * @returns Promise that resolves to an array of Note objects
   */
  async getNotesByChapterId(chapterId: number): Promise<Note[]> {
    const response = await apiClient.get<ApiResponse<ListNotesResponse>>(
      `/notes/chapter/${chapterId}`
    );
    return response.data.data.notes;
  },
  
  /**
   * Get a note by ID
   * @param id The ID of the note to retrieve
   * @returns Promise that resolves to a Note object
   */
  async getNoteById(id: number): Promise<Note> {
    const response = await apiClient.get<ApiResponse<Note>>(`/notes/${id}`);
    return response.data.data;
  },

  /**
   * Create a new note
   * @param noteData The note data to create
   * @returns Promise that resolves to the created Note object
   */
  async createNote(noteData: { content: string, chapter_id: number, display_order?: number }): Promise<Note> {
    const response = await apiClient.post<ApiResponse<Note>>('/notes', noteData);
    return response.data.data;
  },

  /**
   * Update an existing note
   * @param id The ID of the note to update
   * @param noteData The note data to update
   * @returns Promise that resolves to the updated Note object
   */
  async updateNote(id: number, noteData: { content?: string, chapter_id?: number, display_order?: number }): Promise<Note> {
    const response = await apiClient.put<ApiResponse<Note>>(`/notes/${id}`, noteData);
    return response.data.data;
  },

  /**
   * Delete a note
   * @param id The ID of the note to delete
   * @returns Promise that resolves when the note is deleted
   */
  async deleteNote(id: number): Promise<void> {
    await apiClient.delete<ApiResponse<void>>(`/notes/${id}`);
  }
};